<template>
  <div class="l-footer">
    <div class="l-footer__content g-content">
      <div class="mobile-show">
        <logo />
        <div class="foundation-name">
          <foundation-name />
        </div>
        <div class="consult-info">
          <consult-info />
        </div>
        <div class="buttons">
          <buttons />
        </div>
        <divide whiteDashed mt="30" mb="30" />
        <social-medias />
      </div>

      <div class="tablet-show">
        <logo />

        <div class="info">
          <div class="info__left">
            <foundation-name />
            <divide whiteDashed mt="30" mb="30" />
            <social-medias />
          </div>
          <div class="info__right">
            <consult-info />
          </div>
        </div>

        <div>
          <buttons />
        </div>
      </div>

      <div class="pc-show">

        <div class="info">
          <foundation-name />
          <consult-info />
          <divide whiteDashed mt="30" mb="30" />
          <social-medias />
        </div>
        <div class="sitemap">
          <sitemap />
        </div>
        <div class="buttons">
          <buttons />
        </div>
      </div>
    </div>

    <img class="l-footer__bg-mobile" src="@/assets/img/landing/bg_mobile.png" />
    <img class="l-footer__bg" src="@/assets/img/index/footer_bg.png" />

    <!-- 旗子 -->
    <!-- <img class="flag" src="@/assets/img/landing/deco_flag.png" /> -->

    <!-- 雲朵們，定位 1-5 由左往右 -->
    <img class="cloud cloud--1" src="@/assets/img/landing/deco_cloud_1.png" />
    <img class="cloud cloud--2" src="@/assets/img/landing/deco_cloud_2.png" />
    <img class="cloud cloud--3" src="@/assets/img/landing/deco_cloud_2.png" />
    <img class="cloud cloud--4" src="@/assets/img/landing/deco_cloud_3.png" />
    <img class="cloud cloud--5" src="@/assets/img/landing/deco_cloud_1.png" />

    <!-- 鳥？ -->
    <div class="bird-purple">
      <img class="bird-purple__img" src="@/assets/img/landing/deco_bird_purple.png" />
    </div>
    <div class="bird-red">
      <img class="bird-red__img" src="@/assets/img/landing/deco_bird_red.png" />
    </div>
    <div class="bird-blue">
      <img class="bird-blue__img" src="@/assets/img/landing/deco_bird_blue.png" />
    </div>

  </div>
</template>
<script>
import { defineComponent } from 'vue';
import Logo from '@/layout/Footer/Logo.vue';
import FoundationName from '@/layout/Footer/FoundationName.vue';
import ConsultInfo from '@/layout/Footer/ConsultInfo.vue';
import Sitemap from '@/layout/Footer/Sitemap.vue';
import SocialMedias from '@/layout/Footer/SocialMedias.vue';
import Buttons from '@/layout/Footer/Buttons.vue';
import Divide from '@/components/Global/Divide.vue';

export default defineComponent({
  name: 'Footer',
  components: {
    Logo,
    FoundationName,
    ConsultInfo,
    Sitemap,
    SocialMedias,
    Buttons,
    Divide,
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';

.l-footer {
  width: 100%;
  position: relative;
  background: $c-main-pink;
  padding-top: 30px;
  padding-bottom: 450px;

  &__content {

    position: relative;
    z-index: 10;
    @include flex(center);
  }

  &__bg-mobile {
    width: 100%;

    @include position(bl, 0, 0);
    vertical-align: bottom;

    @media screen and (min-width: $portrait) {
      display: none;
    }
  }

  &__bg {
    width: 100%;
    @include position(bl, 0, 0);
    display: none;
    vertical-align: bottom;

    @media screen and (min-width: $portrait) {
      display: block;
    }
  }
}

.mobile-show {
  .foundation-name {
    margin-top: 30px;
  }

  .consult-info {
    margin-top: 30px;
  }

  .buttons {
    // margin-top: 30px;
    @include flex(center);
  }
}

.tablet-show {
  display: none;
}

.pc-show {
  display: none;
}

@media screen and (min-width: $mobile) {
}

@media screen and (min-width: $portrait) {
}

@media screen and (min-width: $tablet) {
  .mobile-show {
    display: none;
  }

  .tablet-show {
    display: block;

    .info {
      margin-top: 30px;
      @include flex(space-between, flex-start);

      &__left {
        flex: none;
        width: 50%;
      }

      &__right {
        width: 50%;
        margin-left: 40px;
      }
    }
  }
}

@media screen and (min-width: $pc) {
  .l-footer {
    padding-top: 100px;
    padding-bottom: 400px;
  }
  .mobile-show {
    display: none;
  }

  .tablet-show {
    display: none;
  }

  .pc-show {
    width: 100%;
    @include flex(flex-start, flex-start);

    .info {
      flex: none;
      width: 380px;
    }

    .sitemap {
      flex: 1;
      margin-left: 20px
    }

    .buttons {
      flex: none;
      width: 150px;
      margin-left: 10px

    }

  }
}

@media screen and (min-width: $lg-pc) {
  .l-footer {
    padding-bottom: 500px;
  }
}

.cloud {
  position: absolute;

  &--1 {
    display: none;

    @media screen and (min-width: $tablet) {
      display: inline-block;
      width: 10.5vw;
      top: 70px;
      left: 3vw;
      animation: 2s cloudFlow infinite forwards linear;
    }

    @media screen and (min-width: $sm-pc) {
      left: 3vw;

    }

    @media screen and (min-width: $pc) {
      display: none;
    }
  }

  &--2 {
    display: none;

    @media screen and (min-width: $tablet) {
      display: none;

    }

    @media screen and (min-width: $pc) {
      width: 7vw;
      animation: 2.3s cloudFlow infinite forwards linear;
      display: inline-block;
      top: 320px;
      left: 2vw;
    }
  }
  &--3 {
    display: none;

  }
  &--4 {
    display: none;

    @media screen and (min-width: $tablet) {
      display: inline-block;
      width: 8vw;
      top: 25%;
      left: 85%;
      animation: 2.1s cloudFlow infinite forwards linear;
    }

    @media screen and (min-width: $sm-pc) {
      top: 58%;
      left: 90%;
    }
  }

  &--5 {
    display: none;

    @media screen and (min-width: $tablet) {
      display: inline-block;
      width: 10.5vw;
      bottom: 50%;
      right: -5%;
      animation: 1.8s cloudFlow infinite forwards linear;
    }

  }
}

.bird-purple {
  @include position(bl, 7vw, 38%);

  @media screen and (min-width: $portrait) {
    bottom: 4vw;
  }

  &__img {
    width: 9vw;
    animation: 20s purpleBirdWalking infinite linear;

    @media screen and (min-width: $portrait) {
      width: 4.5vw;
    }
  }
}

.bird-red {
  @include position(bl, 5vw, 45%);

  @media screen and (min-width: $portrait) {
    bottom: 3vw;
  }

  &__img {
    width: 9vw;
    animation: 15s redBirdWalking infinite linear;

    @media screen and (min-width: $portrait) {
      width: 4.5vw;
    }
  }
}

.bird-blue {
  @include position(bl, 6vw, 60%);

  @media screen and (min-width: $portrait) {
    bottom: 2vw;
  }

  &__img {
    width: 22vw;
    animation: 2s blueFlow infinite linear;

    @media screen and (min-width: $portrait) {
      width: 10vw;
    }
  }
}

@media screen and (min-width: $lg-pc) {}

@keyframes cloudFlow {
  0% {
    transform: translateX(0px) rotate(0deg);
  }

  25% {
    transform: translateX(5px) rotate(5deg);
  }

  75% {
    transform: translateX(-5px) rotate(-5deg);
  }

  100% {
    transform: translateX(0px) rotate(0deg);
  }
}

@keyframes purpleBirdWalking {
  0% {
    transform: translateX(0px);
  }

  24% {
    transform: translateX(10vw);
  }

  25% {
    transform: translateX(10vw) rotateY(180deg);
  }

  75% {
    transform: translateX(-10vw) rotateY(180deg);
  }

  76% {
    transform: translateX(-10vw) rotateY(0deg);
  }

  100% {
    transform: translateX(0px);
  }
}

@keyframes redBirdWalking {
  0% {
    transform: translateX(0px);
  }

  24% {
    transform: translateX(7vw);
  }

  25% {
    transform: translateX(7vw) rotateY(180deg);
  }

  75% {
    transform: translateX(-7vw) rotateY(180deg);
  }

  76% {
    transform: translateX(-7vw) rotateY(0deg);
  }

  100% {
    transform: translateX(0px);
  }
}

@keyframes blueFlow {
  0% {
    transform: translateX(0px) rotate(0deg);
  }

  25% {
    transform: translateX(5px) rotate(1deg);
  }

  75% {
    transform: translateX(-5px) rotate(-1deg);
  }

  100% {
    transform: translateX(0px) rotate(0deg);
  }
}

</style>
